import { Container } from '../../components/container'
import { Line } from '../../components/line'
import { cn } from '../../utils/cn'
import { ButtonCms } from '../button/button.cms'
import { RichText } from '../helper-components/rich-text'

interface TextCardColumnCmsProps {
  id: string
  title?: any
  description?: any
  columnOneTitle: string
  columnTwoTitle: string
  columnOneCardsCollection: Array<any>
  columnTwoCardsCollection: Array<any>
}

export const TextCardColumnCms = (props: TextCardColumnCmsProps) => {
  const Column = (props: { columnTitle: any; columnCollection: any }) => {
    return (
      <div
        className={cn(
          'bg-background mb-5 p-4 md:px-8 md:py-6 flex flex-col',
          props.columnCollection?.length === 2
            ? 'flex-[2] sm:max-sm:max-w-[30.5rem]'
            : 'flex-1 sm:max-w-[30.5rem]'
        )}
      >
        <div className="flex justify-center">
          <h3 className="font-sans max-w-[23.375rem] p-6 text-center text-base leading-relaxed md:p-0 text-neutral-900 md:text-2xl">
            {props.columnTitle}
          </h3>
        </div>
        <div className="items-stretch justify-center gap-7 md:flex md:flex-row md:pt-6 xl:justify-between flex-1">
          {props.columnCollection.map((item: any, i: any) => (
            <div key={i} className="pb-5 md:pb-0 flex-1 lg:min-w-[18rem]">
              <PackageOverviewCard card={item} />
            </div>
          ))}
        </div>
      </div>
    )
  }
  const PackageOverviewCard = (props: { card: any }) => {
    return (
      <div
        className="flex-col justify-between
        rounded-none border border-tan-150 bg-white p-6 md:flex h-full"
      >
        <div className="pb-7 text-center text-sm md:flex-col">
          <div className="pb-[.5rem] uppercase">{props.card.label}</div>
          <Line />
        </div>
        <RichText
          className="text-center text-3xl leading-relaxed text-neutral-900 font-medium"
          json={props.card.title?.json}
          links={props.card.title?.links}
        />
        <RichText
          className="pt-4 text-center text-base leading-loose"
          json={props.card.description?.json}
          links={props.card.description?.links}
        />
        <div>
          {props.card.button && (
            <div className="mt-6 mb-2 text-center">
              <ButtonCms content={props.card.button}></ButtonCms>
            </div>
          )}
        </div>
      </div>
    )
  }
  return (
    <Container className="md:py-6 scroll-mt-25" id={props.id}>
      <div className="items-center gap-6 py-12 md:flex md:flex-row md:py-20">
        <RichText
          className="pb-6 font-serif text-4xl text-neutral-900 md:py-6 md:text-5xl leading-[3.6rem]"
          json={props.title?.json}
          links={props.title?.links}
        />
        <RichText
          className="text-base md:text-2xl leading-[2.4rem]"
          json={props.description.json}
          links={props.description.links}
        />
      </div>
      <div className="-mx-6 justify-center items-center md:mx-0 flex flex-col lg:flex-row lg:gap-x-4 lg:flex-wrap lg:items-stretch">
        <Column
          columnTitle={props.columnOneTitle}
          columnCollection={props.columnOneCardsCollection}
        />
        <Column
          columnTitle={props.columnTwoTitle}
          columnCollection={props.columnTwoCardsCollection}
        />
      </div>
    </Container>
  )
}
